import { Controller, type Control } from "react-hook-form";
import type { WeddingQuoteInput } from "@/lib/plan-wizard-schema";

const OPTIONS = [
  { value: "delivery", label: "Delivery" },
  { value: "pickup", label: "Pickup" },
] as const;

/** Drop-off: delivery or pickup (#1221). Native radios, so arrow keys move
 * between the two for free; the chip styling sits on the label. */
export function FulfillmentChoice({ control, error }: { control: Control<WeddingQuoteInput>; error?: string }) {
  return (
    <fieldset
      className="grid gap-2"
      aria-labelledby="w-fulfillment-label"
      aria-describedby={error ? "w-fulfillment-error" : undefined}
    >
      <legend id="w-fulfillment-label" className="mb-2 text-sm font-medium leading-none">
        Delivery or pickup?
      </legend>
      <Controller
        control={control}
        name="fulfillment"
        render={({ field }) => (
          <div className="flex flex-wrap gap-2">
            {OPTIONS.map((o, i) => {
              const selected = field.value === o.value;
              return (
                <label
                  key={o.value}
                  className={`inline-flex min-h-[44px] cursor-pointer items-center rounded-full border px-4 py-1.5 text-sm transition-colors focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 ${
                    selected
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border bg-background hover:border-primary/40"
                  }`}
                >
                  <input
                    type="radio"
                    id={`w-fulfillment-${o.value}`}
                    name={field.name}
                    value={o.value}
                    checked={selected}
                    onChange={() => field.onChange(o.value)}
                    onBlur={field.onBlur}
                    // react-hook-form focuses this on a failed submit.
                    ref={i === 0 ? field.ref : undefined}
                    aria-invalid={!!error}
                    className="sr-only"
                  />
                  {o.label}
                </label>
              );
            })}
          </div>
        )}
      />
      {error && (
        <p id="w-fulfillment-error" role="alert" className="text-xs text-destructive">{error}</p>
      )}
    </fieldset>
  );
}
